import { COLUMN_LABELS } from '../../../common/components/materials/materialPresentationConstants';
import { COLUMN_FILTER_OPERATORS } from '../constants/materialDashboardConstants';
import { materialCell } from '../../../utils/materialDisplay';

/**
 * Texto del chip de un filtro por columna aplicado: columna, símbolo del operador y valor.
 * @param {{column: string, operator: string, value: string}} filter Filtro aplicado.
 * @returns {string} Etiqueta legible.
 */
export const getColumnFilterLabel = (filter) => {
  const columnLabel = COLUMN_LABELS[filter.column] || filter.column;
  const symbol =
    COLUMN_FILTER_OPERATORS.find((option) => option.value === filter.operator)?.symbol ||
    filter.operator;
  return `${columnLabel} ${symbol} ${materialCell(filter.column, filter.value)}`;
};
